module.exports = __webpack_public_path__ + "img/模板1.be306340.png";